module.exports = __webpack_public_path__ + "static/media/checklist-svgrepo-com.bfa615ba.svg";